import React from "react";
import skull from "../img/skull.svg";

export default class Error404 extends React.Component {
  render() {
    return (
      <div className="container">
        <section className="hero is-fullheight ">
          <div className="hero-body">
            <div className="container has-text-centered">
              <h1 className="title">ERREUR 404</h1>
              <h2 className="subtitle">Cette page ne semble pas exister!</h2>

              <figure className="image is-128x128 margin-auto">
                <img alt="skul" src={skull} />
              </figure>
              <br />
              <p>
                Si elle est supposée exister, veuillez contacter un responsable!
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Error404.js